import { ErrorCatch } from "./core";

export default ErrorCatch;
